<template>
  <CreateEditResultModal
    v-if="showCreateEditResultModal"
    :projectId="projectId"
    :resultId="resultIdSelected"
    @closeModal="closeModal"
  />
  <DeleteResultModal
    v-if="showDeleteResultModal"
    :projectId="projectId"
    :resultId="resultIdSelected"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Entregas</h6>
      <div v-if="canEditProject" class="ms-auto">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          title="Adicionar Entrega ao Sumário Executivo"
          @click="createEditResult()"
        >
          Adicionar Entrega
        </button>
      </div>
    </div>
    <div v-if="results.length > 0" class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Resultados Esperados</th>
            <th>Tipo</th>
            <th v-if="canEditProject" class="text-center actions">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="result in results" :key="result.id">
            <td>{{ result.description }}</td>
            <td>{{ result.type }}</td>
            <td v-if="canEditProject" class="text-center">
              <button
                type="button"
                class="btn btn-outline-danger btn-icon rounded-pill"
                title="Excluir"
                @click="deleteResult(result.id)"
              >
                <i class="ph-trash" />
              </button>
              <button
                type="button"
                class="btn btn-outline-warning btn-icon rounded-pill ms-2"
                title="Editar"
                @click="createEditResult(result.id)"
              >
                <i class="ph-pencil" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="card-body text-center">
      <p class="mb-0">
        Este sumário executivo não possui nenhuma entrega cadastrada
      </p>
    </div>
  </div>
</template>

<script>
import CreateEditResultModal from '@/components/projects/results/CreateEditResultModal.vue'
import DeleteResultModal from '@/components/projects/results/DeleteResultModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ResultsProject',

  components: {
    CreateEditResultModal,
    DeleteResultModal,
    LoadingData,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditResultModal: false,
      showDeleteResultModal: false,
      results: {},
      resultIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['canEditProject']),
  },

  methods: {
    async getResults() {
      try {
        this.results = await this.$store.dispatch(
          'getProjectResults',
          this.projectId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditResult(resultId) {
      this.resultIdSelected = resultId || null
      this.showCreateEditResultModal = true
    },

    deleteResult(resultId) {
      this.resultIdSelected = resultId
      this.showDeleteResultModal = true
    },

    closeModal(loadListResults) {
      if (loadListResults) {
        this.getResults()
      }
      this.showCreateEditResultModal = false
      this.showDeleteResultModal = false
    },
  },

  mounted() {
    this.getResults()
  },
}
</script>
